import React from 'react';
import { Card, CardContent } from './ui/card';
import { Search, FileText, Calendar, Hammer, CheckCircle, ClipboardCheck } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      icon: Search,
      number: '01',
      title: 'Analyse du support',
      description: 'Inspection détaillée de votre façade pour identifier l\'état du support, les pathologies et les contraintes techniques.'
    },
    {
      icon: FileText,
      number: '02',
      title: 'Visite technique',
      description: 'Déplacement de nos experts sur site pour prendre les mesures, évaluer les accès et définir les solutions adaptées.'
    },
    {
      icon: ClipboardCheck,
      number: '03',
      title: 'Proposition détaillée',
      description: 'Remise d\'un devis complet précisant les travaux, matériaux, délais et tarifs de manière transparente.'
    },
    {
      icon: Calendar,
      number: '04',
      title: 'Planification chantier',
      description: 'Organisation logistique du chantier : échafaudage, accès, coordination avec copropriété et déclarations préalables.'
    },
    {
      icon: Hammer,
      number: '05',
      title: 'Réalisation travaux',
      description: 'Exécution des travaux dans le respect des règles de l\'art, des DTU et avec un suivi qualité permanent.'
    },
    {
      icon: CheckCircle,
      number: '06',
      title: 'Réception chantier',
      description: 'Visite finale avec le client, vérification de la conformité et remise des documents de garanties.'
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Notre Méthodologie
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Notre méthode de travail
          </h2>
          <p className="text-xl text-slate-600">
            De l'analyse initiale à la réception des travaux, un accompagnement complet et transparent
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {steps.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <Card 
                  key={index}
                  className="relative border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 bg-white group overflow-hidden"
                >
                  {/* Number Badge */}
                  <div className="absolute top-0 right-0 w-24 h-24 bg-emerald-50 rounded-bl-full flex items-start justify-end p-4">
                    <span className="text-3xl font-bold text-emerald-600/30 group-hover:text-emerald-600/50 transition-colors">
                      {step.number}
                    </span>
                  </div>

                  <CardContent className="pt-8 pb-8 relative z-10">
                    <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-emerald-600 transition-colors duration-300">
                      <IconComponent className="h-7 w-7 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>

                  {/* Connecting Line (hidden on mobile, shown on larger screens) */}
                  {index < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-emerald-200 z-0"></div>
                  )}
                </Card>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="max-w-2xl mx-auto text-center mt-16">
          <p className="text-lg text-slate-600 mb-6">
            Prêt à démarrer votre projet de rénovation énergétique écologique ?
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-700 hover:to-cyan-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Lancer mon projet
          </button>
        </div>
      </div>
    </section>
  );
};

export default Process;
